import { Link } from '@tanstack/react-router';
import { Icon } from '../components/Icon.tsx';
import { t } from '../lib/strings.ts';

export function NotFound(): JSX.Element {
  return (
    <div className="min-h-screen flex items-center justify-center px-4" dir="rtl">
      <div className="w-full max-w-sm rounded-3xl bg-[hsl(var(--chrome))] p-10 text-center space-y-4">
        <span className="mx-auto grid size-14 place-items-center rounded-full bg-[hsl(var(--secondary-container))] text-[hsl(var(--on-secondary-container))]">
          <Icon name="error" size={28} />
        </span>
        <p className="num text-4xl font-bold leading-none text-ink">{t.notFound.heading}</p>
        <p className="text-muted-foreground">{t.notFound.body}</p>
        <Link to="/" className="btn-secondary btn-sm inline-flex">{t.notFound.goHome}</Link>
      </div>
    </div>
  );
}
